import { useRouter } from "vue-router";

export const useBreadcrumbs = () => {
  const router = useRouter();
  const backLink = router.options.history.state.back?.toString() ?? null;
  let backLabel: string | null = null;

  if (backLink?.endsWith("/maps/")) {
    backLabel = "Back to Maps";
  } else if (backLink?.startsWith("/explore")) {
    backLabel = "Back to Explore";
  } else if (backLink?.startsWith("/discover")) {
    backLabel = "Back to Discover";
  } else {
    const match = backLink?.match(/^\/@([^/]+)(\/|$)/);
    if (match) {
      backLabel = `Back to ${match[1]}`;
    }
  }

  return {
    backLink,
    backLabel,
  };
};
